// extracted by mini-css-extract-plugin
module.exports = {"title":"newHito_title__3HM5x","frame":"newHito_frame__1Y2_F","boxTitle":"newHito_boxTitle__2pZo-","devButton":"newHito_devButton__3CYh0","result":"newHito_result__2Se4l"};